module.exports = __webpack_public_path__ + "media/stock-footageglow-bright.a4747602.mp4";